/**
 * Brand Constants
 * Add your brand details here.
 */
const isProd = import.meta.env?.PROD ?? false
const title = isProd ? "NeighborCloud" : "DEV: NeighborCloud";
const helpDeskUrl = 'https://help.neighborcloud.app'

export const siteConfig = {
  siteTitle: title,
  siteDescription:
    'Your neighborhood association in the cloud.',
  siteUrl: 'https://neighborcloud.app',
  siteImage: '/images/og-image.png',
  favicon: '/favicon.ico',
  twitterHandle: '@neighborcloud.app',
  email: 'support@neighborcloud.app',
  address: '',
  helpDeskUrl,
}

/** Brand hex colors for gradients and inline styles (e.g. setup journey). */
export const brandColors = {
  darkBlue: '#102E36',
  blue: '#297582',
  mediumBlue: '#1c4e56',
  mustard: '#eaa95c',
  minty: '#a8c992',
  warning: '#f2d120',
} as const
